export enum PermissionResource {
  Employee = 'Employee',
  Project = 'Project',
  Role = 'Role',
  Stats = 'Stats',
  Test = 'Test',
  Organization = 'Organization',
  Theme = 'Theme',
}
